import { Breadcrumb } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import AppTypography from './typography/Typography';

export default function AppBreadcrumb({ items = [] }) {
  const breadcrumbItems = items.map((item, index) => {
    const isLast = index === items.length - 1;
    return {
      title: isLast ? (
        <AppTypography variant="body" weight="medium" color="link">
          {item.label}
        </AppTypography>
      ) : (
        <Link to={item.href}>
          <AppTypography variant="body" color="secondary">
            {item.label}
          </AppTypography>
          {item.dropdown && <DownOutlined />}
        </Link>
      ),
    };
  });

  return <Breadcrumb items={breadcrumbItems} />;
}